import { useRef as f, useEffect as L, useMemo as I } from "react";
import { f as m } from "./templateResolver-BchYA4i9.js";
import "./use-definition-0yWcQDPI.js";
import "./fetcher-CUYp7JR1.js";
const S = "loadingStatusItems";
function d() {
  return m.getState().get(S) || [];
}
function g(t) {
  m.getState().set(S, t);
}
function l(t) {
  const n = d();
  if (n.find((s) => s.id === t.id)) {
    const s = n.map(
      (e) => e.id === t.id ? { ...e, ...t } : e
    );
    g(s);
  } else
    g([...n, t]);
}
function a(t, n) {
  const s = d().map(
    (e) => e.id === t ? { ...e, ...n } : e
  );
  g(s);
}
function D() {
  const t = m((r) => r[S]) || [], n = t.some(
    (r) => r.status === "loading"
  ), c = t.length > 1 && t.every((r) => r.status === "success"), s = t.some(
    (r) => r.status === "error"
  ), e = c || s, i = t.filter(
    (r) => r.status === "error"
  );
  return {
    items: t,
    registerStatus: l,
    updateStatus: a,
    isLoading: n,
    isSuccess: c,
    hasError: s,
    isDone: e,
    errorItems: i
  };
}
function N(t, n = "", c = "loading") {
  const s = n || t, e = f(!1), i = f(t), r = f(s), o = f(c);
  return L(() => ((!e.current || i.current !== t || r.current !== s) && (l({
    id: t,
    name: s,
    status: c
  }), e.current = !0, i.current = t, r.current = s), () => {
    e.current && (e.current = !1);
  }), [t, s, c]), { ...I(() => ({
    setLoading: (u) => {
      o.current = "loading", a(t, { status: o.current, message: u });
    },
    setSuccess: (u) => {
      o.current = "success", a(t, { status: o.current, message: u });
    },
    setError: (u, p) => {
      o.current = "error", a(t, { status: o.current, error: u, message: p });
    },
    updateStatus: (u) => {
      u.status && (o.current = u.status), a(t, u);
    }
  }), [t]), status: o.current };
}
export {
  S as L,
  D as a,
  N as u
};
